import run from '../../utilities/run';
import $ from 'jquery';
const _ = require("underscore");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import { SUCCESS_MODAL_TIMEOUT } from "../../constants";
import { setOptionsForSelect, setElementsFromScope } from "../../utilities/selectorHelpers";


run(".rma-web-lite-main-div", (mainEl) => {
	const rmaWebLiteFormDiv = mainEl.find(".rma-web-lite-form-div");
	const requestValidationFailed = mainEl.data("validation-failed");
  const usaStates = mainEl.data('usa-states');
  const returnReasonDomainList = mainEl.data('rma-web-lite-return-reasons-domain-list'); 
  const rmaWebLiteReturnReasonsSelect = mainEl.find("#rmaWebLiteReturnReasonSelect");
  const rmaWebLiteStateSelect = mainEl.find("#rmaWebLiteState");
  const rmaWebLiteState = mainEl.find("#rmaWebLiteState");
  const rmaWebLiteFirstName = mainEl.find("#rmaWebLiteFirstName");
  const rmaWebLiteLastName = mainEl.find("#rmaWebLiteLastName");
  const rmaWebLiteEmail = mainEl.find("#rmaWebLiteEmail");
   const rmaWebLiteRmaNumber = mainEl.find("#rmaWebLiteRmaNumber");  
	const rmaWebLitePhoneNumber = mainEl.find("#rmaWebLitePhoneNumber");
  const rmaWebLiteAddressLine1 = mainEl.find("#rmaWebLiteAddressLine1");
  const rmaWebLiteAddressLine2 = mainEl.find("#rmaWebLiteAddressLine2");
  const rmaWebLiteCity = mainEl.find("#rmaWebLiteCity");  
  const rmaWebLitePostalCode = mainEl.find("#rmaWebLitePostalCode");
  const rmaWebLiteNumberOfLabels = mainEl.find("#rmaWebLiteNumberOfLabels");
  const rmaWebLiteReferenceNumber = mainEl.find("#rmaWebLiteReferenceNumber");
  const rmaWebLiteDepartmentNumber = mainEl.find("#rmaWebLiteDepartmentNumber");
  const rmaWebLitePurchaseOrder = mainEl.find("#rmaWebLitePoNumber");
  const rmaWebLiteInvoiceNumber = mainEl.find("#rmaWebLiteInvoiceNumber");

  const rmaWebLitShowReviewSectionBtn = mainEl.find(".rma-web-lite-review-section-btn");
  const rmaWebLiteReviewSectionDiv = mainEl.find(".rma-web-lite-review-section-div")
  const rmaWebLiteShowFormSectionBtn = mainEl.find(".rma-web-lite-form-section-btn");

  const rmaWebLiteNameReview = mainEl.find("#rmaWebLiteNameReview");
  const rmaWebLiteEmailReview = mainEl.find("#rmaWebLiteEmailReview");
  const rmaWebLiteRmaNumberReview = mainEl.find("#rmaWebLiteRmaNumberReview");
	const rmaWebLitePhoneNumberReview = mainEl.find("#rmaWebLitePhoneNumberReview");
	const rmaWebLiteAddressLine1Review = mainEl.find("#rmaWebLiteAddressLine1Review");
  const rmaWebLiteAddressLine2Review = mainEl.find("#rmaWebLiteAddressLine2Review");
  const rmaWebLiteCityStatePostalCodeReview = mainEl.find("#rmaWebLiteCityStatePostalCodeReview");
  const rmaWebLiteReturnReasonReview = mainEl.find("#rmaWebLiteReturnReasonReview");
  const rmaWebLiteNumberOfLabelsReview = mainEl.find("#rmaWebLiteNumberOfLabelsReview");
  const rmaWebLiteDepReview = mainEl.find("#rmaWebLiteDepReview");
  const rmaWebLitePoReview = mainEl.find("#rmaWebLitePoReview");
  const rmaWebLiteInvReview = mainEl.find("#rmaWebLiteInvReview");
  const rmaWebLiteReferenceNumberReview = mainEl.find("#rmaWebLiteReferenceNumberReview"); 

  const createReturnRmaWebLiteUrl = mainEl.data("create-rma-url");
	const createWebLiteRma = mainEl.find("#create-web-lite-rma");
	const generateLabelBtn = mainEl.find("#generate-rma-web-lite-label");
  const submitModalFlow = new SubmitModalFlow();

  const rmaWebLiteAuthDetails = mainEl.data("rma-web-lite-auth-details");
  const accessToken = mainEl.find(".accessToken");
  const retailerId = mainEl.find(".retailerId");
  const partnerId = mainEl.find(".partnerId");
  const rmaId = mainEl.find(".rmaIdForShipping");


  const editSaveSection = mainEl.find(".edit-save-section");
  const generateLabelSection = mainEl.find(".generate-label-section");
  const returnLabelUrl = mainEl.data("return-label-url");
	const pendingRaLabelSection = mainEl.find(".pending-ra-label-section");
  const rmaSubmitError = mainEl.find(".create-web-lite-rma-error");
  const rmaWebLiteDefaultError = mainEl.data("rma-web-lite-default-error");

  load();

  function setFormValidation() {
    let validator, validationOpts;
    validationOpts = {
      debug: true,
      errorPlacement: function (error, element) {
        let appendClosest = $(element).data('error-placement-append-closest');
        if (appendClosest) {
          $(element).closest(appendClosest).append(error);
        } else {
          error.insertAfter(element);
        }
      }
    }
    validator = rmaWebLiteFormDiv.validate(validationOpts);
    validator.settings.ignore = ":disabled,:hidden";
  }

  function load() {
		setInitialDisplay();
    submitModalFlow.init();
    rmaWebLiteReviewSectionDiv.hide();
    setFormValidation();
    setOptionsForSelect({
      selectElement: rmaWebLiteStateSelect,
      list: usaStates,
      valueDataKey: "cdmValue",
      textDataKey: "cdmMeaning"      
    });
   //E-67372 RMA Web Lite
   setInitialDisplay();
   submitModalFlow.init();
   rmaWebLiteReviewSectionDiv.hide();
   setFormValidation();
   setOptionsForSelect({
     selectElement: rmaWebLiteReturnReasonsSelect,
     list: returnReasonDomainList,
     valueDataKey: "cdmValue",
     textDataKey: "cdmMeaning"      
   }); 
	}

	function setInitialDisplay(){
		if(requestValidationFailed){
			rmaWebLiteFormDiv.hide();
		}else{
			rmaWebLiteFormDiv.show();
		}
	}

  rmaWebLitShowReviewSectionBtn.on('click', function (e) {
    e.preventDefault();
    if (rmaWebLiteFormDiv.valid()) {
      rmaWebLiteReviewSectionDiv.show();
      loadReviewPage();
      rmaWebLiteFormDiv.hide();
    }
  });

  rmaWebLiteShowFormSectionBtn.on('click', function () {
    rmaWebLiteFormDiv.show();
    rmaWebLiteReviewSectionDiv.hide();
  });

  function loadReviewPage() {
    rmaWebLiteNameReview.text(rmaWebLiteFirstName.val() + ' ' + rmaWebLiteLastName.val());
    rmaWebLiteEmailReview.text(rmaWebLiteEmail.val());
	rmaWebLiteRmaNumberReview.text(rmaWebLiteRmaNumber.val());
	rmaWebLitePhoneNumberReview.text(rmaWebLitePhoneNumber.val());
    rmaWebLiteAddressLine1Review.text(rmaWebLiteAddressLine1.val());
    rmaWebLiteAddressLine2Review.text(rmaWebLiteAddressLine2.val());
    rmaWebLiteCityStatePostalCodeReview.text(rmaWebLiteCity.val() + ',' + rmaWebLiteState.val() + ' ' + rmaWebLitePostalCode.val());
	rmaWebLiteReturnReasonReview.text(rmaWebLiteReturnReasonsSelect.find(":selected").text());	
	rmaWebLiteNumberOfLabelsReview.text(rmaWebLiteNumberOfLabels.val());
    rmaWebLiteReferenceNumberReview.text(rmaWebLiteReferenceNumber.val());
    rmaWebLiteDepReview.text(rmaWebLiteDepartmentNumber.val());
    rmaWebLitePoReview.text(rmaWebLitePurchaseOrder.val());
    rmaWebLiteInvReview.text(rmaWebLiteInvoiceNumber.val());	
  }

  function setRmaWebLiteAuthDetails() {
    accessToken.val(rmaWebLiteAuthDetails.accessToken);
    retailerId.val(rmaWebLiteAuthDetails.retailerId);
    partnerId.val(rmaWebLiteAuthDetails.partnerId);
  }

	createWebLiteRma.on("click", function (e) {
    e.preventDefault();
    save({ url: createReturnRmaWebLiteUrl, success: saveSuccess, error: saveError });
  });

  function save({ url, success, error }) {
    setRmaWebLiteAuthDetails();
    submitModalFlow.showLoadingModal();
    $.ajax({
      data: new FormData($('.rma-web-lite-form-div').get(0)),
      url: url,
      processData: false,
      contentType: false,
      dataType: "JSON",
      type: 'POST',
      success: success,
      error: error
    });
  }

  function saveSuccess(data) {
    if (data.status == "Success") {
      rmaSubmitError.hide();
      rmaId.val(data.data);
      EditChecker.setPageClean();
      submitModalFlow.showSuccessModal();
      setTimeout(function () { submitModalFlow.hideAllModals(); }, SUCCESS_MODAL_TIMEOUT);
     // START B-1355197 Replace Print label Verbiage
	 if(data.retAuthReq == "Approved"){
          showGetLabelBtn();
      }
      else if(data.retAuthReq == "Pending - RA Required"){
          showGetPendigLabelBtn();
      }
	  // END B-1355197 Replace Print label Verbiage
    } else {
      saveError(data);
    }
  }

  function saveError(data) {
    submitModalFlow.hideAllModals();
    rmaSubmitError.show();
    if (data.errorMessage != null) {
      rmaSubmitError.text(data.errorMessage);
    } else {
      rmaSubmitError.text(rmaWebLiteDefaultError);
    }
  }

  function showGetLabelBtn() {
    editSaveSection.hide();
    generateLabelSection.show();
  }
  
  // START B-1355197 Replace Print label Verbiage
    function showGetPendigLabelBtn(){
      editSaveSection.hide();
      pendingRaLabelSection.show();
  }
// END B-1355197 Replace Print label Verbiage
	generateLabelBtn.on("click", function () {
    let url = `${returnLabelUrl}&rmaIdForShipping=${rmaId.val()}&accessToken=${accessToken.val()}&retailerId=${retailerId.val()}`
    window.open(url);
  })
});



// WEBPACK FOOTER //
// ./src/pages/rmaWebLite/rmaEntryLiteVersionForm.js